<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="841px"
      @close="setDialogClosed" append-to-body>
      <el-container direction="vertical" style="height: 500px">
        <ul style="overflow: auto; margin-right: 20px">
          <el-descriptions :column="4" border style="margin-bottom: 10px">
            <el-descriptions-item :span="2" label="姓名">
              <el-input v-model="detail.content.patientName" placeholder="请输入内容" style="width: 200px"></el-input>
            </el-descriptions-item>

            <el-descriptions-item :span="2" label="编号">
              <el-input v-model="detail.content.followupId" placeholder="请输入内容" style="width: 200px"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="2" label="随访时间">
              <el-date-picker v-model="detail.startTime" type="date" placeholder="选择日期" style="width: 200px">
              </el-date-picker>
            </el-descriptions-item>

            <el-descriptions-item span="2" label="随访方式">
              <el-select v-model="detail.content.followUpType" placeholder="请选择">
                <el-option v-for="item in followUpTypeOptions" :key="item.value" :label="item.label" :value="item.value"
                  style="width: 200px">
                </el-option>
              </el-select>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="症状">
              <el-input v-model="detail.symptom" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="体征">
              <el-descriptions :column="1" border style="
                                          margin-top: -11px;
                                          margin-left: -11px;
                                          margin-bottom: -11px;
                                          margin-right: -11px;
                                        ">
                <el-descriptions-item label="舒张压(mmHg)">
                  <el-input v-model="detail.content.sbp"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="收缩压(mmHg)">
                  <el-input v-model="detail.content.dbp"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="体重(kg)">
                  <el-input v-model="detail.content.weight"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="身高(cm)">
                  <el-input v-model="detail.content.height"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="体质指数(kg/㎡)">
                  <el-input v-model="detail.content.bmi"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="腰围(cm)">
                  <el-input v-model="detail.content.waist"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="心率(次/每分钟)">
                  <el-input v-model="detail.content.heartrate"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="足背动脉搏动">
                  <el-input v-model="detail.content.dorsalisPedisPulse"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="其他">
                  <el-input v-model="detail.content.signsOther"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="生活方式指导">
              <el-descriptions :column="1" border style="
                                          margin-top: -11px;
                                          margin-left: -11px;
                                          margin-bottom: -11px;
                                          margin-right: -11px;
                                        ">
                <el-descriptions-item label="日吸烟量(支)">
                  <el-input v-model="detail.content.smokePerday"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="日饮酒量(两)">
                  <el-input v-model="detail.content.drinkPerday"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="运动">
                  <el-input v-model="detail.content.sportPerweek"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="主食(克/每天)">
                  <el-input v-model="detail.content.nutritionMainPerday"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="摄盐情况(咸淡)">
                  <el-input v-model="detail.content.salt"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="心理调整">
                  <el-input v-model="detail.content.mentalAdjustment"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="遵医行为">
                  <el-input v-model="detail.content.docktorObey"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="目前用药情况">
              <el-descriptions :column="1" border style="
                                          margin-top: -11px;
                                          margin-left: -11px;
                                          margin-bottom: -11px;
                                          margin-right: -11px;
                                        ">
                <template slot="extra">
                  <el-button type="primary" size="small" @click="addDrug()"
                    style="margin-top: 10px; margin-right: 10px">新增用药</el-button>
                </template>
                <el-descriptions-item label="用药" v-for="(item, index) in detail.content.medicines" :key="index">
                  <el-input v-model="item.name" placeholder="药品名称" style="width: 200px"></el-input>
                  <el-input v-model="item.value" placeholder="用法用量" style="width: 200px; margin-left: 10px"></el-input>
                  <el-button type="primary" size="small" @click="deleteDrug(index)"
                    style="margin-left: 10px">删除</el-button>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="服药依从性">
              <el-input v-model="detail.content.medicationAdherence" placeholder="请输入内容"></el-input>
              <el-select v-model="detail.content.medicationAdherence" placeholder="请选择">
                <el-option v-for="item in medicationAdherenceOptions" :key="item.value" :label="item.label"
                  :value="item.value" style="width: 200px">
                </el-option>
              </el-select>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="药物不良反应">
              <el-input v-model="detail.content.medicationBadEvent" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="低血糖反应">
              <el-input v-model="detail.content.hypoglycemiaReaction" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="辅助检查">
              <el-descriptions :column="1" border style="
                                          margin-top: -11px;
                                          margin-left: -11px;
                                          margin-bottom: -11px;
                                          margin-right: -11px;
                                        ">
                <el-descriptions-item label="空腹血糖值(mmol/L)">
                  <el-input v-model="detail.content.emptyGlu"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="糖化血红蛋白(%)">
                  <el-input v-model="detail.content.hba1c"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="检查日期">
                  <el-date-picker v-model="detail.content.examTime" type="date" placeholder="选择日期" style="width: 200px">
                  </el-date-picker>
                </el-descriptions-item>

                <el-descriptions-item label="其他">
                  <el-input v-model="detail.content.examOther"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="年度并发症筛查检查">
              <el-input v-model="detail.content.complicationContent" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="本年度并发症">
              <el-input v-model="detail.content.complication" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="此次随访分类">
              <el-input v-model="detail.followup_type" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="下次管理措施">
              <el-input v-model="detail.content.manageNext" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="用药调整意见">
              <el-input v-model="detail.content.medicationAdvise" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="协诊或转诊到位情况">
              <el-descriptions :column="1" border style="
                                          margin-top: -11px;
                                          margin-left: -11px;
                                          margin-bottom: -11px;
                                          margin-right: -11px;
                                        ">
                <el-descriptions-item label="原因">
                  <el-input v-model="detail.content.referralReason"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="机构及科别">
                  <el-input v-model="detail.content.referralDept"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="联系人">
                  <el-input v-model="detail.content.referralDoctor"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="电话">
                  <el-input v-model="detail.content.tc"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="结果">
                  <el-input v-model="detail.content.referralResult"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="随访医生签名">
              <el-input v-model="detail.content.doctor" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="居民签名">
              <el-input v-model="detail.content.patientName" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="备注">
              <el-input v-model="detail.content.remark" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="下次随访日期">
              <el-date-picker v-model="detail.content.nextfollowuptime" type="date" placeholder="选择日期"
                style="width: 200px">
              </el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
        </ul>
        <el-button type="primary" size="small" @click="submit()"
          style="margin-top: 10px; margin-left: 670px;width:100px;">提交</el-button>
      </el-container>
    </el-dialog>
  </div>
</template>

<script>
import { commitFollowUp } from "@/api/health/Patients";
export default {
  components: {},
  data() {
    return {
      showDialog: false,
      title: "新建随访",
      list: null,
      listLoading: false,
      listQuery: {
        patientId: null,
        reportCode: null,
      },
      pId: null,
      detail: {
        id: '',
        patientId: "",
        idcard: "",
        healthNo: "",
        manager_hospital: "",
        service_hispital: "",  // 随访机构
        service_name: "高血压随访",
        commitTime: "",
        status: "已完成",
        patientName: "",
        followup_id: "",
        startTime: "",
        symptom: "",
        content: {
          sbp: "",
          dbp: "",
          weight: "",
          bmi: null,
          height: "",
          bmi: "",
          waist: "",
          hip: "",
          heartrate: "",
          dorsalisPedisPulse: "",
          signsOther: "",
          smokePerday: "",
          drinkPerday: "",
          sportPerweek: "",
          nutritionMainPerday: "",
          salt: "",
          mentalAdjustment: "",
          docktorObey: "",
          medicines: [
            {
              name: "",
              value: ""
            }
          ],
          medicationAdherence: "",
          medicationBadEvent: "",
          hypoglycemiaReaction: "",
          emptyGlu: "",
          hba1c: "",
          tg: "",
          tc: "",
          hdlc: "",
          ldlc: "",
          examTime: "",
          examOther: "",
          complicationContent: "",
          complication: "",
          followUpType: "",
          manageNext: "",
          medicationAdvise: "",
          referralReason: "",
          referralDept: "",
          referralDoctor: "",
          referralPhone: "",
          referralResult: "",
          doctor: "",
          doctor: "",
          patientName: "",
          remark: "",
          nextfollowuptime: "",
          followupId: "",
          idcard: null,
        },
      },
      followUpTypeOptions: [
        {
          value: "1",
          label: "电话随访",
        },
        {
          value: "2",
          label: "线上随访",
        },
        {
          value: "3",
          label: "上门随访",
        },
      ],
      medicationAdherenceOptions: [
        {
          value: "规律",
          lebel: "规律"
        },
        {
          value: "间断",
          lebel: "间断"
        },
        {
          value: "服药",
          lebel: "服药"
        },
        {
          value: "不服药",
          lebel: "不服药"
        },
      ]
    };
  },
  created() {
  },
  methods: {
    // 编辑初始化页面内容
    async init(dataContext) {
      console.log(dataContext);
      this.getSystemTime();
      this.detail.id = dataContext.id;
      this.detail.patientId = dataContext.patientId;
      this.detail.idcard = dataContext.idcard;
      this.detail.healthNo = dataContext.healthNo;
      this.manager_hospital = dataContext.managerHospital;
      this.detail.patientName = dataContext.name;
      this.detail.content.patientName = dataContext.name;

      // this.detail.service_hispital = 
      this.showDialog = true;
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.showDialog = false;
    },
    addDrug() {
      var drugItem = {
        name: "",
        value: "",
      };
      this.detail.content.medicines.push(drugItem);
    },
    deleteDrug(index) {
      this.detail.content.medicines.splice(index, 1);
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth() + 1;
      // 获取日期(1-31)
      var date = time.getDate();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");

      // 合并返回
      this.detail.commitTime = year + "-" + month + "-" + date;
    },
    // 日期格式转化
    getParseDate(time) {
      var newTime = new Date(time);
      return (
        newTime.getFullYear() +
        "-" +
        newTime.getMonth() +
        "-" +
        newTime.getDate()
      );
    },
    submit() {

      this.detail.content.bmi = Number(this.detail.content.weight / (Math.pow(this.detail.content.height / 100, 2))).toFixed(2)

      let params = this.detail;
      commitFollowUp(params).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: "新建随访成功！",
            type: "success",
          });
          this.showDialog = false;
        } else if (res.code == "500") {
          this.$message({
            message: res.msg,
            type: "error",
          });
        } else {
          this.$message({
            message: "新建随访失败！",
            type: "error",
          });
        }
      }).catch((error) => {
        console.log(error);
      })
    }
  },
};
</script>

<style lang="less" scoped></style>